import { render } from "./Comunicado.vue?vue&type=template&id=5d0e1642"
import script from "./Comunicado.vue?vue&type=script&lang=js"
export * from "./Comunicado.vue?vue&type=script&lang=js"

import exportComponent from "/dados/apps/pdcrm/app_atual/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__